import { batch } from 'react-redux'
import { downloadFile, generateBlob } from '@chilecompra/react-kit'

import { getTaxation } from '../../services/config'
import { deleteFileSeller, getAttachedFilesSeller, getDowloadFileSeller, uploadFileSeller } from '../../services/files'
import { makeActionCreator } from '../../config/store/utils'

export const GET_TAXATION = 'GET_TAXATION'
export const GET_TAXATION_ERROR = 'GET_TAXATION_ERROR'
export const GET_TAXATION_SUCCESS = 'GET_TAXATION_SUCCESS'
export const onGetTaxation = makeActionCreator(GET_TAXATION)
export const onGetTaxationError = makeActionCreator(GET_TAXATION_ERROR, 'payload')
export const onGetTaxationSuccess = makeActionCreator(GET_TAXATION_SUCCESS, 'payload')

export const onGetTaxationThunk = () => async dispatch => {
  dispatch(onGetTaxation())

  try {
    const { data } = await getTaxation()

    const taxation = data.payload.impuestos.map(impuesto => ({
      name: impuesto.nombre,
      value: impuesto.codigo,
      percentage: impuesto.porcentaje,
      withHolding: impuesto.conRetencion
    }))

    return dispatch(onGetTaxationSuccess({ taxation }))
  } catch (error) {
    return dispatch(onGetTaxationError({ error }))
  }
}

export const SAVE_QUOTE_SELLER_SUCCESS = 'SAVE_QUOTE_SELLER_SUCCESS'
export const onSaveQuoteSellerSuccess = makeActionCreator(SAVE_QUOTE_SELLER_SUCCESS, 'payload')

export const UPLOAD_FILE_SELLER = 'UPLOAD_FILE_SELLER'
export const UPLOAD_FILE_SELLER_SUCCESS = 'UPLOAD_FILE_SELLER_SUCCESS'
export const UPLOAD_FILE_SELLER_ERROR = 'UPLOAD_FILE_SELLER_ERROR'
export const onUploadFileSeller = makeActionCreator(UPLOAD_FILE_SELLER)
export const onUploadFileSellerError = makeActionCreator(UPLOAD_FILE_SELLER_ERROR, 'payload')
export const onUploadFileSellerSuccess = makeActionCreator(UPLOAD_FILE_SELLER_SUCCESS, 'payload')

export const onUploadFileSellerThunk = payload => async dispatch => {
  dispatch(onUploadFileSeller())
  try {
    await uploadFileSeller(payload)
    return batch(() => {
      dispatch(onUploadFileSellerSuccess())
      dispatch(onGetAttachedFilesSellerThunk({ quoteCode: payload.quoteCode }))
    })
  } catch (error) {
    if (error?.code === 400) {
      const err = error?.originalError?.response?.data?.errores?.map(error => ({
        code: error?.codigo,
        description: error?.descripcion
      }))

      return dispatch(onUploadFileSellerError({ error: err }))
    }

    dispatch(onUploadFileSellerError({ error: {} }))
  }
}

export const GET_ATTACHED_FILES_SELLER = 'GET_ATTACHED_FILES_SELLER'
export const GET_ATTACHED_FILES_SELLER_SUCCESS = 'GET_ATTACHED_FILES_SELLER_SUCCESS'
export const GET_ATTACHED_FILES_SELLER_ERROR = 'GET_ATTACHED_FILES_SELLER_ERROR'
export const onGetAttachedFilesSeller = makeActionCreator(GET_ATTACHED_FILES_SELLER)
export const onGetAttachedFilesSellerError = makeActionCreator(GET_ATTACHED_FILES_SELLER_ERROR, 'payload')
export const onGetAttachedFilesSellerSuccess = makeActionCreator(GET_ATTACHED_FILES_SELLER_SUCCESS, 'payload')

export const onGetAttachedFilesSellerThunk = payload => async dispatch => {
  dispatch(onGetAttachedFilesSeller())

  try {
    const { data } = await getAttachedFilesSeller({ quoteCode: payload.quoteCode })
    const attachedFiles = data.payload?.adjuntos?.map(attachedFile => ({
      id: attachedFile.id,
      name: attachedFile.filename
    }))

    dispatch(onGetAttachedFilesSellerSuccess({ attachedFiles }))
  } catch (error) {
    if (error.code === 400) {
      const err = error.originalError.response.data.errores.map(error => ({
        code: error.codigo,
        description: error.descripcion
      }))

      return dispatch(onGetAttachedFilesSellerError({ error: err }))
    }

    dispatch(onGetAttachedFilesSellerError({ error: {} }))
  }
}

export const GET_DOWNLOAD_FILE = 'GET_DOWNLOAD_FILE'
export const GET_DOWNLOAD_FILE_ERROR = 'GET_DOWNLOAD_FILE_ERROR'
export const GET_DOWNLOAD_FILE_SUCCESS = 'GET_DOWNLOAD_FILE_SUCCESS'
export const onGetDownloadFile = makeActionCreator(GET_DOWNLOAD_FILE)
export const onGetDownloadFileError = makeActionCreator(GET_DOWNLOAD_FILE_ERROR, 'payload')
export const onGetDownloadFileSuccess = makeActionCreator(GET_DOWNLOAD_FILE_SUCCESS, 'payload')
export const onGetDownloadFileThunk = payload => async dispatch => {
  dispatch(onGetDownloadFile())

  try {
    const { data, headers } = await getDowloadFileSeller({ fileId: payload.id })
    const blob = generateBlob(data, headers['content-type'])
    downloadFile(blob, payload.name)
    return dispatch(onGetDownloadFileSuccess())
  } catch (error) {
    if (error.code === 400) {
      const err = error.originalError.response.data.errores.map(error => ({
        code: error.codigo,
        description: error.descripcion
      }))

      return dispatch(onGetDownloadFileError({ error: err }))
    }

    return dispatch(onGetDownloadFileError({ error: {} }))
  }
}

export const DELETE_FILE = 'DELETE_FILE'
export const DELETE_FILE_ERROR = 'DELETE_FILE_ERROR'
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS'
export const onDeleteFile = makeActionCreator(DELETE_FILE)
export const onDeleteFileError = makeActionCreator(DELETE_FILE_ERROR, 'payload')
export const onDeleteFileSuccess = makeActionCreator(DELETE_FILE_SUCCESS, 'payload')
export const onDeleteFileThunk = payload => async dispatch => {
  dispatch(onDeleteFile())
  const { fileId, ipUsuario, quoteCode } = payload

  try {
    await deleteFileSeller({ fileId, ipUsuario })
    return batch(() => {
      dispatch(onDeleteFileSuccess())
      dispatch(onGetAttachedFilesSellerThunk({ quoteCode }))
    })
  } catch (error) {
    if (error.code === 400) {
      const err = error.originalError.response.data.errores.map(error => ({
        code: error.codigo,
        description: error.descripcion
      }))

      return dispatch(onDeleteFileError({ error: err }))
    }

    return dispatch(onDeleteFileError({ error: {} }))
  }
}

export const HIDE_ERRORS_QUOTE_BID_SELLER_SUCCESS = 'HIDE_ERRORS_QUOTE_BID_SELLER_SUCCESS'
export const onHideErrorsQuoteBidSellerSuccess = makeActionCreator(HIDE_ERRORS_QUOTE_BID_SELLER_SUCCESS, 'payload')

export const ADD_OFFER_SUCCESS = 'ADD_OFFER_SUCCESS'
export const onAddOfferSuccess = makeActionCreator(ADD_OFFER_SUCCESS, 'payload')

export const CLEAR_ATTACHED_FILES_SUCCESS = 'CLEAR_ATTACHED_FILES_SUCCESS'
export const onClearAttachedFilesSuccess = makeActionCreator(CLEAR_ATTACHED_FILES_SUCCESS)

export const SHOW_ERROR_AMOUNT_SUCCESS = 'SHOW_ERROR_AMOUNT_SUCCESS'
export const onShowErrorAmountSuccess = makeActionCreator(SHOW_ERROR_AMOUNT_SUCCESS, 'payload')

export const DISABLED_INPUT = 'DISABLED_INPUT'
export const onDisabledInput = makeActionCreator(DISABLED_INPUT, 'payload')
